import Phaser from 'phaser';

import pageParams from './pageParams';

export default {
    type: Phaser.AUTO,
    parent: 'game-container',
    // backgroundColor: '#33A5E7',
    // backgroundColor: '#F5F5F5',
    startAnimationDuration: 2000,
    startAnimationDelay: 1000,
    finishAnimationDuration: pageParams.screenSize === 's' || pageParams.screenSize === 'm' ? 700 : 1200,
    siteAnimationDuration: {
        main: 700,
        direction: {
            mazeOpacity: 800,
            mazeMoving: 800,
            ball: 500,
        },
    },
    width: pageParams.clientWidth,
    height: pageParams.clientHeight,
    resolution: pageParams.dpr,
    render: {
        transparent: true,
    },
    physics: {
        default: 'arcade',
        arcade: {
            // debug: true,
            // debugShowVelocity: true,
            // debugShowBody: true,
            // debugShowStaticBody: true,
        },
    },
};
